<template>
  <div>
    <v-layout wrap justify-center>
      <v-flex xs12 pt-5>
        <v-img :src="mediaURL + product.photos[0]" height="150px" contain>
          <template v-slot:placeholder> <ImageLoader /> </template>
        </v-img>
      </v-flex>
    </v-layout>
    <v-layout wrap justify-center px-2 pt-2 pb-5>
      <v-flex xs12 text-left style="line-height: 16px; cursor: pointer">
        <v-layout wrap justify-center>
          <v-flex xs12>
            <span
              style="
                font-family: poppinsmedium;
                font-size: 12px;
                color: #000000;
              "
            >
              {{ product.productname.slice(0, 18) }}
              <span v-if="product.productname.length > 18"> ... </span>
            </span>
          </v-flex>
          <v-flex xs12>
            <span
              style="
                font-family: poppinsregular;
                font-size: 11px;
                color: #5e5e5e;
              "
            >
              {{ product.seller.organization }}
            </span>
          </v-flex>
          <v-flex xs6>
            <span
              style="
                font-family: poppinssemibold;
                font-size: 13px;
                color: #000000;
              "
            >
              Rs. {{ product.price }}
            </span>
          </v-flex>
          <v-flex xs6>
            <span
              class="pl-2 text-decoration-line-through"
              style="
                font-family: poppinsregular;
                font-size: 13px;
                color: #ff0000;
              "
              v-if="product.offer > 0"
            >
              Rs. {{ product.orginalprice }}
            </span>
          </v-flex>
          <v-flex xs12>
            <span>
              <v-rating
                v-model="product.ratingcount"
                color="#FFD341"
                background-color="#e0e0e0"
                empty-icon="$ratingFull"
                half-increments
                readonly
                hover
                small
              ></v-rating>
            </span>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
export default {
  props: ["product", "cardWidth"],
  data() {
    return {
    };
  },
};
</script>